'use strict';
import angular from 'angular';
import util from '../util/util.module';
import ngCookies from 'angular-cookies';
import { routerDecorator } from './router.decorator';
import { AuthService } from './auth.service';
import UserService from './user.service';
import uiRouter from 'angular-ui-router';
import { AuthEvents } from './auth.events';
export default angular.module('eeComUiApp.auth', [util, ngCookies, uiRouter])
    .run(routerDecorator)
    .service('AuthEvents', AuthEvents)
    .factory('Auth', AuthService)
    .service('User', UserService)
    .name;
//# sourceMappingURL=auth.module.js.map